import { Checkbox } from '@mui/material';
import React, { useContext, useMemo } from 'react';
import OrderedCheckboxIcon from '../OrderedCheckboxIcon';
import SelectionContext from './SelectionContext';

/**
 * @typedef Props
 * @property {import('@mui/x-data-grid').GridRowId} rowId
 */

/**
 * @param {Props & import('@mui/material').CheckboxProps} props
 */
export default function OrderedCheckbox({ rowId, ...other }) {
    const { selectionModel } = useContext(SelectionContext);

    const index = useMemo(() => {
        return selectionModel.indexOf(rowId);
    }, [selectionModel, rowId]);

    // NB: Ultimately DataGrid provides the interaction for us, this part is just for show.
    return (
        <Checkbox
            checked={index !== -1}
            checkedIcon={(
                <OrderedCheckboxIcon
                    order={index + 1}
                />
            )}
            {...other}
        />
    );
}